// extracted by mini-css-extract-plugin
module.exports = {"card":"jgp-3yItt","card_content":"jgp-2xVpT","card_name_and_date_wrapper":"jgp-2lefZ"};